import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/financial',
  component: layout,
  meta: {
    funcID: 'C0002',
    PID: 'C00',
  },
  children: ((pre) => [
    {
      path: 'noInvoiceQuery',
      name: `${pre}noInvoiceQuery`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000201',
        PID: 'C00',
      },
      component: () => import('@/views/financial/financial/noInvoiceQuery'),
    },
    {
      path: 'userMaterialAbnormal',
      name: `${pre}userMaterialAbnormal`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000202',
        PID: 'C00',
      },
      component: () => import('@/views/financial/financial/userMaterialAbnormal'),
    },
    {
      path: 'userMaterialAbnormal/:pageType/:code?',
      name: `${pre}userMaterialAbnormal-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { materialAbnormalNo = '' } = $route.query || {}
          if (materialAbnormalNo) {
            return `合祥物料异常联络单 | ${materialAbnormalNo}`
          }
          return '合祥物料异常联络单'
        },
        funcID: 'C000202',
        PID: 'C00',
      },
      component: () => import('@/views/financial/financial/userMaterialAbnormal/detail'),
    },
  ])('financial-financial-'),
}
